import React from "react";
import ImgHome from "../../img/ImgHome.png";
import Matches from "../../img/Matches";
import Champ from "../../img/Champ";
import { useTranslation } from "react-i18next";

import {
  Container,
  ContainerIcon,
  ContainerTextIcon,
  Img,
  ContainerText,
  Title,
  Subtitle,
  TextIcon,
  IconContainer,
} from "./styled";
import { useScroll } from "../../context/UseContextScroll";

const ForeCasts = () => {
  const [t] = useTranslation("global");
  const { scroll } = useScroll();
  const arrayForeCasts = [
    {
      id: 1,
      title: t("matches.matches"),
      subtitle: t("textMatches.textMatches"),
      icon: Matches,
    },
    {
      id: 2,
      title: t("champion.champion"),
      subtitle: t("textChampion.textChampion"),
      icon: Champ,
    },
  ];
  return (
    <Container>
      <div>
        <Img scroll={scroll} src={ImgHome} alt="img" />
      </div>
      <ContainerText>
        <Title>{t("titleForecasts.titleForecasts")}</Title>
        <Subtitle>{t("foreCats.foreCats")}</Subtitle>
        {arrayForeCasts.map((item) => (
          <ContainerIcon key={item.id}>
            <IconContainer>
              <item.icon />
            </IconContainer>
            <ContainerTextIcon>
              <h4>{item.title}</h4>
              <TextIcon scroll={scroll}>{item.subtitle}</TextIcon>
            </ContainerTextIcon>
          </ContainerIcon>
        ))}
      </ContainerText>
    </Container>
  );
};

export default ForeCasts;
